import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-product-report',
  templateUrl: './product-report.component.html',
  styleUrls: ['./product-report.component.css']
})
export class ProductReportComponent implements OnInit {
  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;



  myOptions: INgxMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any;
  brands: any = [];
  sortOrder = 0;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  covenants: any = [
    { provinceID: 1 },
    { provinceID: 2 },
    { provinceID: 3 },
    { provinceID: 4 },
    { provinceID: 5 },
  ];

  openCoverages = false;
  indexSelectedCoverage = 1;

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.model['brand'] = '';
    this.model['product_type'] = '';
    this.model['short_desc'] = '';
    this.model['balance_percent'] = '';
    this.model['stock_location'] = '';
    this.model['stock_area'] = '';
    this.model.choose_report = '0';
    // this.displayedColumns = this.columnNames.map(x => x.id);
    this.loginservice.getBrands('', this.currentUser)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this.brands = data['data'];
            this.model.brand = 'All';
          } else {
            this.brands = [];
          }
        }, error => { alert('Network Error getBrands API'); });

    this.productReport('');

    this.covenants.forEach((_covenants) => {
      _covenants.isExpanded = false;
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  sortable(sort) {
    let order = ""
    if (this.sortOrder == 0) {
      order = "DESC";
      this.sortOrder = 1;
    } else {
      order = "ASC";
      this.sortOrder = 0;
    }
    let data = {
      brand: this.model['brand'],
      product_type: this.model['product_type'],
      short_desc: this.model['short_desc'],
      stock_location: this.model['stock_location'],
      stock_area: this.model['stock_area'],
      balance_percent: this.model['balance_percent'],
      sort: sort,
      sortOrder: order
    };
    this.productReport(data)
  }

  productReport(data) {
    this.loginservice.productReport(data, this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.dataresult = data['comp_details'];
            this.certList.contractorId = this.model['Id'];
            this.certList.uid = this.currentUser['uid'];
            this.certificate = data;
            this.showLoader = false;
            let tableArr: Element[] = data['comp_details'];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          } else {
            this.dataresult.length = 0;
            this.showLoader = false;
            let tableArr: Element[] = [];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          }
        },
        error => {
          alert('Network Error productReport API');
          this.showLoader = false;
        });
  }

  @ViewChild('excel_table') table: ElementRef;
  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);//converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'Products In Service.xlsx');
  }

  public mprint() {
    window.print();
  }

  parseInt(val) {
    return parseInt(val);
  }

  search() {
    let order = "";
    let data = {
      brand: this.model['brand'],
      product_type: this.model['product_type'],
      short_desc: this.model['short_desc'],
      stock_location: this.model['stock_location'],
      stock_area: this.model['stock_area'],
      balance_percent: this.model['balance_percent'],
      sort: '',
      sortOrder: order
    };
    this.productReport(data)
  }

  chooseReport() {
    if (this.model.choose_report == '0') {

    } else if (this.model.choose_report == '1') {
      this.router.navigate(['/productUsageReport']);
    } else if (this.model.choose_report == '2') {
      this.router.navigate(['/productInService']);
    } else if (this.model.choose_report == '3') {
      this.router.navigate(['/servicesInproduct']);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/product-report/product-report.component.ts